module.exports = __webpack_public_path__ + "img/logo-esa.a346bc2d.png";